<template>
  <div>
  <p-button :is-busy="ispaymentMethodBusy" @click="showModal" no-border class="ps-2 d-inline">
                    <i class="fas fa-external-link-alt"></i
                ></p-button>
     <p-modal      
        size="lg"
        label="Department Charge Details"
        ref="departmentChargeModal_"
    >
        <template v-slot:default>
            <p-form ref="form">
                <b-row  cols="1" cols-lg="2" v-if="updatedPayment.promptDetails && updatedPayment.promptDetails.length > 0">
                        <b-col v-for="promptDetail in updatedPayment.promptDetails"
                            :key="promptDetail.promptName">
                                <p-input
                                    :label="promptDetail.promptName"
                                    v-model="promptDetail.promptValue"
                                    :rules="promptDetail.isRequired?'required|max:50':'max:50'"
                                />
                        </b-col>
                </b-row>
                <b-row cols="1">
                    <b-col>
                        <p-text-area
                            label="Special Comments"
                            v-model="updatedPayment.specialComments"
                            :disabled="true"
                        />
                    </b-col>
                </b-row>
            </p-form>
        </template>

        <template v-slot:modal-footer="{ ok, cancel }">
            <b-row>
                <b-col>
                    <b-button :is-busy="isBusy" variant="outline-primary" @click="cancel">Cancel</b-button>
                    <p-button :is-busy="isBusy" variant="primary" @click="saveDetails" class="ms-2">Save</p-button>
                </b-col>
            </b-row>
        </template>
    </p-modal>
  </div>
</template>

<script>

export default {
 props: {
          paymentMethod:{},
          ispaymentMethodBusy: {
            type: Boolean,
            default: false
          }
        },
    data() {
        return { 
            isBusy:false,
            updatedPayment: {}
         };
    },
    methods: {        
        saveDetails: async function() {
            this.$emit('save', this.updatedPayment);
            this.$refs['departmentChargeModal_'].hide();
        },
        showModal(){
            this.updatedPayment = JSON.parse(JSON.stringify(this.paymentMethod));
            this.$refs['departmentChargeModal_'].show();               
        }
    }
}
</script>